import React from "react";
import Card from "./card";

export default ({ data }) => {
  return (
    <div className="flex flex-col z-10 bg-[#161a2f] w-full">
      <h1 className="title text-left mb-2 ml-2">{data.headline}</h1>
      <h3 className="text-base md:text-lg text-left pl-2 mt-3">Financial Highlights</h3>
      {data.financial_highlights.map(({ sentiment, highlight }) => (
        <Card type={sentiment} value={highlight} />
      ))}
      <h3 className="text-base md:text-lg text-left pl-2 mt-6 md:mt-10">
        Key Products &amp; Strategies
      </h3>
      {data.key_projects_or_strategies.map(
        ({ status, key_project_or_strategy }) => (
          <Card type={status} value={key_project_or_strategy} />
        )
      )}
      <h3 className="text-base md:text-lg text-left pl-2 mt-6 md:mt-10">Bull Cases</h3>
      {data.bull_cases.map(({ title, details }) => (
        <Card type="positive" value={title} />
      ))}
      <h3 className="text-base md:text-lg text-left pl-2 mt-6 md:mt-10">Bear Cases</h3>
      {data.bear_cases.map(({ title, details }) => (
        <Card type="negative" value={title} />
      ))}
    </div>
  );
};
